export default __webpack_public_path__ + "static/media/edit-duplicate.743240bf.png";